<section class="compare-sec">
  <div class="filter-icon pt-5 pb-2">
    <span class="clickable" id="open-filter" (click)="openFilter = !openFilter"><i class="fa fa-filter"
        aria-hidden="true"></i> Filter</span>
  </div>
  <div *ngIf="openFilter">
    <form class="row" [formGroup]="form" (submit)="submitSearch()">
      <div class="col-12">
        <h5 class="title">Load types</h5>
        <label class="radio-inline" *ngFor="let loadTestTypes of loadTestTypes">
          <input type="radio" name="loadTestType" value="{{ loadTestTypes }}" formControlName="loadTestType"
            (change)="resetApiType()" />
          {{ loadTestTypes }}
        </label>
        <hr />
      </div>
      <div class="col-3 mb-2">
        <ng-select class="custom-style" [clearable]="false" id="my-project" formControlName="projectIds"
          placeholder="Select Project(s)" [items]="userProjects" (change)="getProjectRelatedData()" bindLabel="name"
          bindValue="id">
          <ng-template ng-option-tmp let-item="item">
            <div title="{{ item.name }}" class="text-truncate">{{ item.name }}</div>
          </ng-template>
        </ng-select>
      </div>
      <div class="col-4 mb-2">
        <ng-select class="custom-style" [clearable]="false" formControlName="testCaseId" placeholder="Select testcase"
          [items]="testCasesList" bindLabel="name" bindValue="id" (change)="submitSearch()"></ng-select>
      </div>
      <div class="col-3 mb-2">
        <ng-select class="custom-style" [multiple]="true" id="project-user" formControlName="userIds"
          placeholder="Select Users(s)" bindLabel="displayName" bindValue="id" [items]="projectUsers"></ng-select>
      </div>
      <div class="col-2 mb-2">
        <ng-select class="custom-style" formControlName="executionStatus" [items]="executionStatuses"
          placeholder="Select Status"></ng-select>
      </div>
      <div class="col-3">
        <ng-select class="custom-style" [clearable]="false" formControlName="location" placeholder="Location"
          [items]="locations"></ng-select>
      </div>
      <div class="col-4">
        <input class="form-control form-control-sm" type="text" placeholder="Start Date" name="dt"
          formControlName="startDate" (click)="dt.toggle()" ngbDatepicker #dt="ngbDatepicker" placement="bottom"
          (dateSelect)="setEndDate($event)" [maxDate]="startdate" autocomplete="off" />
      </div>
      <div class="col-3">
        <input class="form-control form-control-sm" type="text" placeholder="End Date" name="dt1"
          formControlName="endDate" (click)="dt1.toggle()" ngbDatepicker #dt1="ngbDatepicker" placement="bottom"
          (dateSelect)="setDate($event)" [minDate]="enddate" [maxDate]="startdate" autocomplete="off" />
      </div>

      <div class="col text-right">
        <button type="submit" class="btn relay-btn primary"
          [disabled]="!projectIdsValue || !testCaseIdValue">Search</button>
        <a style="display: block;color:white;" class="mt-2 clickable" (click)="clearFilter()">
          <small><i>Clear filter</i></small>
        </a>
      </div>
    </form>
  </div>

  <div class="table-responsive queue-table mt-3">
    <table class="table table-sm">
      <thead>
        <tr class="text-center font-bold">
          <td></td>
          <td class="text-left">Testname</td>
          <td>Type</td>
          <td width="13%">Location</td>
          <td *ngIf="userData.perfLabAdmin || userData.superAdmin">Run Type</td>
          <td>Users</td>
          <td>Schedule Date & Time</td>
          <td>Status</td>
          <td *ngIf="userData.perfLabAdmin">Created By</td>
          <td></td>
        </tr>
      </thead>
      <tbody>
        <tr *ngIf="!queueData">
          <td colspan="10">Please select project and testcase</td>
        </tr>
        <tr *ngIf="queueData && queueData?.performanceRequests.length <= 0">
          <td colspan="10">No data found</td>
        </tr>
        <tr *ngFor="let queueData of queueData?.performanceRequests">
          <td>
            <input type="checkbox" [(ngModel)]="queueData.selected" />
          </td>
          <td>
            <a target="_blank" [routerLink]="['/testcase', queueData.testCase.id]"> <i class="fas fa-link"
                ngbTooltip="Go to Testcase"></i></a>
            <a ngbTooltip="{{ queueData.status === 'SCHEDULED' ? 'Results are not ready' : null }}"
              class="text-truncate"
              [routerLink]="queueData.status !== 'SCHEDULED' ? ['/performance/loadTesting/result', queueData.id, 'queue'] : '.'"
              title="{{ queueData.testCase.name }}" style="padding-left: 0.2em">{{ queueData.testCase?.name }}</a>
          </td>
          <td class="text-center">{{ queueData.testCase?.loadTestType }}</td>
          <td class="text-center">
            <a ngbTooltip="{{ queueData.status === 'SCHEDULED' ? 'Results are not ready' : null }}"
              [routerLink]="queueData.status !== 'SCHEDULED' ? ['/performance/loadTesting/result', queueData.id, 'queue'] : '.'">{{
              queueData.location ? queueData.location : "NA" }}</a>
          </td>
          <td class="text-center" *ngIf="userData.perfLabAdmin || userData.superAdmin">
            <img src="/assets/images/performance/parallel.png" width="20px" *ngIf="queueData.parallelFlow"
              ngbTooltip="Formal run" />
            <img src="/assets/images/performance/sequential.png" width="20px" *ngIf="!queueData.parallelFlow"
              ngbTooltip="Dry run " />
          </td>
          <td class="text-center">
            <a ngbTooltip="{{ queueData.status === 'SCHEDULED' ? 'Results are not ready' : null }}"
              [routerLink]="queueData.status !== 'SCHEDULED' ? ['/performance/loadTesting/result', queueData.id, 'queue'] : '.'">{{
              queueData.noOfUsers > 9 ? queueData.noOfUsers : "0" + queueData.noOfUsers }}</a>
          </td>
          <td class="text-center" title="{{ queueData.status === 'SCHEDULED' ? 'Results are not ready' : null }}">
            <a
              [routerLink]="queueData.status !== 'SCHEDULED' ? ['/performance/loadTesting/result', queueData.id, 'queue'] : '.'">
              {{ queueData.startTime | date:'dd-MM-yy, hh:mm:ss A' }} to
              {{ queueData.endTime | date:'dd-MM-yy, hh:mm:ss A' }}
            </a>
          </td>
          <td class="text-center">
            <img src="/assets/images/performance/completed.png" width="20px" *ngIf="queueData.status === 'PASSED'"
              ngbTooltip="{{ queueData.status }}" />
            <img src="/assets/images/performance/pending.png" width="20px" *ngIf="queueData.status === 'PENDING'"
              ngbTooltip="{{ queueData.status }}" />
            <img src="/assets/images/performance/failed.png" width="20px" *ngIf="queueData.status === 'FAILED'"
              ngbTooltip="{{ queueData.status }}" />
            <img src="/assets/images/performance/abort2.png" width="20px" *ngIf="queueData.status === 'ABORTED'"
              ngbTooltip="{{ queueData.status }}" />
            <img src="/assets/images/performance/inprogress.png" width="20px" *ngIf="queueData.status === 'IN_PROGRESS'"
              ngbTooltip="{{ queueData.status }}" />
            <img src="/assets/images/performance/scheduled.png" width="20px" *ngIf="queueData.status === 'SCHEDULED'"
              ngbTooltip="{{ queueData.status }}" />
            <i class="fas fa-bug" *ngIf="queueData.status === 'RELAY_ERROR'" ngbTooltip="{{ queueData.status }}"></i>
          </td>
          <td class="text-center template-word-wrap" *ngIf="userData.perfLabAdmin"
            title="{{ queueData.createdBy?.displayName }}">
            <span style="font-size: 11px">{{ queueData.createdBy ? queueData.createdBy.userName : "" }}</span>
          </td>
          <td class="text-right">
            <a class="fas fa-redo mr-1" title="Re-run" placement="bottom-right"
              [routerLink]="['/performance/loadTesting/rerun', queueData.id ]" ngbTooltip="Re-run"></a>

          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <!-- Pagination -->
  <div class="row" *ngIf="queueData">
    <div class="col">Results : {{ queueData.count }}</div>
    <div class="col-1">Page : {{ queryParamsData.page }}</div>
    <div class="col-1">Size : {{ queryParamsData.size }}</div>
  </div>
  <hr />
  <section appStickyNav scrollTopVal="100" class="controls-fixed" *ngIf="queueData">
    <div class="row relay-margin-top-10">
      <div class="col-md-12 text-center" *ngIf="queueData">
        <button *ngIf="moreData" class="btn relay-btn primary" (click)="loadMore(page)">LOAD MORE</button>
        <button class="btn relay-btn primary" (click)="goToCompareResult()"
          [disabled]="disableCompare() < 2">COMPARE</button>
      </div>
    </div>
  </section>
</section>